import { util } from 'pevueglobal'
import { setXVtableMutations } from '../XVtableV2'
import { store } from '@/store/'

// state
const state = {
  handelingSettings: {
    zoekDatumVan: null,
    zoekDatumTot: null,
    ienddate: null,
    istartdate: null,
    multiselectedVoorbehouden: [],
    multiselectedfilterV: [],
    multiselectedRisicovolle: [],
    multiselectedfilterR: [],
    hasMobile: false,
    btnwis: false
  },
  voorbehoudenCategories: [],
  risicovolleCategories: [],
  handelingTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: []
  },
  waiter: true
}

// getters
const getters = {
  voorbehoudenCategories: state => state.voorbehoudenCategories,
  risicovolleCategories: state => state.risicovolleCategories,
  handelingTable: state => state.handelingTable,
  waiter: state => state.waiter
}

// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [
      5494,
      8835,
      14508,
      15450,
      15615,
      15616,
      15617,
      15618,
      15619,
      15620,
      15621,
      15622,
      15623,
      15640,
      15641,
      15642,
      15643,
      15644,
      15645,
      15646
    ]
    dispatch('gettranslations', textIDs, { root: true })
  },
  gethandelingen: async ({ commit, state }) => {
    let [handelinglist, handelingTabledata] = await Promise.all([
      util.getDataApi('allroles/PEapi_PR_VVN_Person_Handelingen'),
      util.GetXVTableDataV2('allroles/PEapi_PR_VVN_Person_Handelingen_XVTable')
    ])
    if (handelinglist.status === '200') {
      commit('sethandelingen', handelinglist)
    }
    commit('setXVtabledata', handelingTabledata)
    commit('setXVtableColumnsettings')
    commit('setXVtablesetting')
    commit('initXVtableState', state.handelingTable)
  }
}
// mutations
const mutations = {
  ...setXVtableMutations('handelingTable'),
  sethandelingen(state, data) {
    let startdatum = new Date(Date.now())
    startdatum.setMonth(startdatum.getMonth() - 12)
    state.handelingSettings.istartdate = startdatum
    state.handelingSettings.zoekDatumVan = startdatum
    state.handelingSettings.ienddate = new Date(Date.now())
    state.handelingSettings.zoekDatumTot = new Date(Date.now())
    state.voorbehoudenCategories = data.ds.data0.filter(rij => rij.handelingsType === 'V')
    state.risicovolleCategories = data.ds.data0.filter(rij => rij.handelingsType === 'R')
    if ($('html').hasClass('mobile')) {
      state.handelingSettings.hasMobile = true
    }
    // Geen categorie bovenaan de lijst zetten
    state.voorbehoudenCategories.unshift({
      handelingsName: store.getters.translation(15643), // geen voorbehouden handelingen
      handelingsID: -1,
      handelingsType: 'V'
    })
    // All-categories bovenaan in lijst zetten
    state.voorbehoudenCategories.unshift({
      handelingsName: store.getters.translation(15646), // alle voorbehouden handelingen
      handelingsID: null,
      handelingsType: 'V'
    })
    // Geen categorie bovenaan de lijst zetten
    state.risicovolleCategories.unshift({
      handelingsName: store.getters.translation(15644), // geen risicovolle handelingen
      handelingsID: -1,
      handelingsType: 'R'
    })
    // All-categories bovenaan in lijst zetten
    state.risicovolleCategories.unshift({
      handelingsName: store.getters.translation(15645), // Alle risicovolle handelingen
      handelingsID: null,
      handelingsType: 'R'
    })
    state.handelingSettings.multiselectedVoorbehouden.unshift({
      handelingsName: store.getters.translation(15646), // alle voorbehouden handelingen
      handelingsID: null,
      handelingsType: 'V'
    })
    state.handelingSettings.multiselectedRisicovolle.unshift({
      handelingsName: store.getters.translation(15645), // Alle risicovolle handelingen
      handelingsID: null,
      handelingsType: 'R'
    })
    // state.handelingSettings.multiselectedVoorbehouden.push(state.voorbehoudenCategories[0])
    state.handelingSettings.multiselectedfilterV.push(state.voorbehoudenCategories[0])
    // state.handelingSettings.multiselectedRisicovolle.push(state.risicovolleCategories[0])
    state.handelingSettings.multiselectedfilterR.push(state.risicovolleCategories[0])
    state.waiter = false
  },
  setHandelingSettings(state, handelingSettings) {
    state.handelingSettings = {
      ...state.handelingSettings,
      ...handelingSettings
    }
  },
  setXVtabledata(state, data) {
    state.handelingTable.tabledata = data.tabledata
  },
  setXVtablesetting(state) {
    state.handelingTable.tablesetting = {
      procedure: 'PEapi_PR_VVN_Person_Handelingen_XVTable',
      tableName: 'PersonHandelingen',
      sequence: 1,
      sortable: 1,
      paging: 1,
      pagingSize: 50,
      alwaysShowDetail: null
    }
  },
  setXVtableColumnsettings(state) {
    state.handelingTable.tablecolumnsetting = [
      {
        procedure: 'PEapi_PR_VVN_Person_Handelingen_XVTable',
        tableName: 'PersonHandelingen',
        name: 'dateCompleted',
        sequence: 1,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 15611,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'date',
        sortColumn: 'dateSort',
        widthXS: '100px',
        widthSM: '180px',
        widthMD: '180px',
        helpTextID: null,
        columnname: 'Datum'
      },
      {
        procedure: 'PEapi_PR_VVN_Person_Handelingen_XVTable',
        tableName: 'PersonHandelingen',
        name: 'actName',
        sequence: 2,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 15612,
        visibleXS: 1,
        visibleSM: 1,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Naam'
      },
      {
        procedure: 'PEapi_PR_VVN_Person_Handelingen_XVTable',
        tableName: 'PersonHandelingen',
        name: 'handelingsName',
        sequence: 3,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 15613,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Handeling'
      },
      {
        procedure: 'PEapi_PR_VVN_Person_Handelingen_XVTable',
        tableName: 'PersonHandelingen',
        name: 'handelingsType',
        sequence: 4,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 15640,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: '180px',
        helpTextID: null,
        columnname: 'type handeling'
      },
      {
        procedure: 'PEapi_PR_VVN_Person_Handelingen_XVTable',
        tableName: 'PersonHandelingen',
        name: 'strConclusion',
        sequence: 5,
        sortable: 1,
        sortableDefault: 0,
        visible: 1,
        headerTextID: 15614,
        visibleXS: 0,
        visibleSM: 0,
        visibleMD: 1,
        type: 'string',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: '140px',
        helpTextID: null,
        columnname: 'status'
      },
      {
        procedure: 'PEapi_PR_VVN_Person_Handelingen_XVTable',
        tableName: 'PersonHandelingen',
        name: 'dateSort',
        sequence: 6,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'date',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined'
      },
      {
        procedure: 'PEapi_PR_VVN_Person_Handelingen_XVTable',
        tableName: 'PersonHandelingen',
        name: 'dateStart',
        sequence: 7,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'date',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined'
      },
      {
        procedure: 'PEapi_PR_VVN_Person_Handelingen_XVTable',
        tableName: 'PersonHandelingen',
        name: 'dateEnd',
        sequence: 8,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'date',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined'
      },
      {
        procedure: 'PEapi_PR_VVN_Person_Handelingen_XVTable',
        tableName: 'PersonHandelingen',
        name: 'handelingsID',
        sequence: 9,
        sortable: 0,
        sortableDefault: 0,
        visible: 0,
        headerTextID: null,
        visibleXS: null,
        visibleSM: null,
        visibleMD: null,
        type: 'number',
        sortColumn: null,
        widthXS: null,
        widthSM: null,
        widthMD: null,
        helpTextID: null,
        columnname: 'Text not defined'
      }
    ]
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
